export const BRAND = "INK OF DESTINY";
export const TAGLINE = "Decode Your Numbers. Read Between the Lines.";

export const CONTACT = {
    phone: "9892613427",
    phoneDisplay: "+91 98926 13427",
    whatsapp1: "919892613427",
    whatsapp2: "919664794543",
    email: "theshadesofsoul@gmail.com",
    instagram: "https://www.instagram.com/graphologybymaitrii",
    youtube: "https://youtube.com/@graphologybymaitrii",
    maps: "https://maps.app.goo.gl/TprhQi5JNEyzMmYq5",
    address: "Shop No. 6, Swapna Sangeet, Swapna Nagri, Opp. Om Sai Medical, Yogi Hills, Veena Nagar, Mulund West, Mumbai 400080",
    hours: "11:00 AM – 9:00 PM",
};

export const waLink = (msg) =>
    `https://wa.me/${CONTACT.whatsapp1}?text=${encodeURIComponent(msg)}`;

export const STATS = [
    { value: "3500+", label: "Souls Healed" },
    { value: "8+", label: "Years of Practice" },
    { value: "350+", label: "Students Mentored" },
    { value: "8", label: "Jain Monks Guided" },
];

export const EXPERTISE = [
    "Handwriting Analysis",
    "Signature Analysis & Correction",
    "Doodle Analysis",
    "Numerology & Name Correction",
    "Child Development Specialist",
    "Logo Analysis & Healing",
    "Chakra & Reiki Healing",
    "Crystal Therapy",
    "Vastu Analysis (with Vastudeep)",
    "Visiting Card Specialist",
    "Relationship Counselling",
    "Coaching & Personal Growth",
];

export const SERVICES_MENU = [
    { name: "Signature Analysis", offline: "₹4,000", online: "₹3,600" },
    { name: "Handwriting Analysis", offline: "₹3,600", online: "₹3,300" },
    { name: "Numerology Reading", offline: "₹4,000", online: "₹3,600" },
    { name: "Crystal Remedies", offline: "₹999", online: "₹999" },
    { name: "Namekaran (Naming)", offline: "₹3,900", online: "₹3,300" },
    { name: "Logo Analysis", offline: "₹6,900–9,999", online: "₹6,900" },
    { name: "Relationship Insights", offline: "₹3,600", online: "₹3,300" },
    { name: "Name Correction & Analysis", offline: "₹3,600", online: "₹2,800" },
    { name: "Graphology Classes (Live Course)", offline: "₹12,000", online: "₹12,000" },
    { name: "Numerology Class (Online Zoom)", offline: "₹9,999", online: "₹9,999" },
    { name: "Vastu Analysis (with Vastudeep)", offline: "On Request", online: "On Request" },
];

export const EXPERTISE_IMAGES = {
    "Handwriting Analysis": "/assets/expertise/handwriting-analysis.jpg",
    "Chakra & Reiki Healing": "/assets/expertise/chakra-reiki-healing.jpg",
    "Child Development Specialist": "/assets/expertise/child-development-specialist.jpg",
    "Coaching & Personal Growth": "/assets/expertise/coaching-personal-growth.jpg",
    "Visiting Card Specialist": "/assets/expertise/visiting-card-specialist.jpg",
    "Relationship Counselling": "/assets/expertise/relationship-counselling.jpg",
    "Vastu Analysis (with Vastudeep)": "/assets/expertise/vastu-analysis.jpg",
    "Doodle Analysis": "/assets/expertise/doodle-analysis.jpg",
    "Numerology & Name Correction": "/assets/expertise/numerology-name-correction.jpg",
    "Logo Analysis & Healing": "/assets/expertise/logo-analysis-healing.jpg",
    "Signature Analysis & Correction": "/assets/expertise/signature-analysis.jpg",
    "Crystal Therapy": "/assets/expertise/crystal-therapy.jpg",
};

export const SEMINARS = [
    "Seminar at ISME College",
    "Seminar at ISDI College",
    "Seminar at Rotary Club of Mulund",
    "Proud Member — JBN (JITO Business Group)",
    "Member of JITO Youth",
];

export const QUOTE = "I decode handwriting and numbers — guiding souls and brands towards alignment, clarity, and success.";

export const MISSION = "To heal, inspire, and empower individuals to discover their inner strength, create meaningful relationships, and live a life of purpose and abundance.";

export const PARTNER = {
    name: "Deeppak C Shah",
    brand: "Vastudeep",
    title: "Vastu Consultant",
    phone: "919324076191",
    phoneDisplay: "+91 93240 76191",
};

export const COURSES = [
    {
        name: "Graphology Classes",
        tagline: "Decode Handwriting. Discover True Personality.",
        start: "Starting 16th August 2026",
        mode: "Live Interactive Sessions",
        price: "₹12,000",
        oldPrice: "₹15,000",
        features: ["Introduction to Graphology", "Handwriting Analysis", "Signature Analysis", "Personality & Behavior Traits", "Strengths, Weaknesses & Emotional Patterns", "Practical Case Studies", "Real-Life Applications"],
        perks: ["In-depth Study Material", "Doubt Solving Sessions", "Certificate of Completion", "Personal Guidance"],
        wa: "Hi Maitrii! I want to enrol in the Graphology Classes starting 16th August.",
    },
    {
        name: "Numerology Class",
        tagline: "Decode yourself through numbers.",
        start: "Enrolment Open",
        mode: "Online — Live on Zoom",
        price: "₹9,999",
        oldPrice: "₹12,000",
        features: ["Life Path & Destiny Numbers", "Name Number Analysis", "Personal Year Guidance", "Relationship Numbers", "Future Predictions"],
        perks: ["Live Interactive Sessions", "Expert Guidance", "Life-Changing Insights"],
        wa: "Hi Maitrii! NUMBERS — I want to enrol in the Numerology Class.",
    },
];

export const PACKAGES = [
    {
        name: "Numerology Reading",
        desc: "Life path, name numbers, career & relationship compatibility decoded from your date of birth and name.",
        price: "₹4,000",
        onlinePrice: "₹3,600 online",
        features: ["Life Path & Destiny Analysis", "Name Numerology", "Career & Business Numbers", "Relationship Compatibility", "Crystal Remedies & Therapy", "Grapho Therapy", "6 Months Follow-Up"],
        featured: false,
    },
    {
        name: "Complete Reading",
        desc: "The full INK OF DESTINY experience — numerology and graphology woven into one deep, personalized session.",
        price: "On Request",
        onlinePrice: "Online & In-Person",
        features: ["Everything in Numerology", "Everything in Graphology", "Combined Personalized Report", "Remedies & Healings Included", "Crystal Remedies & Therapy", "Grapho Therapy", "6 Months Follow-Up"],
        featured: true,
    },
    {
        name: "Graphology Reading",
        desc: "Your handwriting and signature reveal what words cannot — personality, emotions and hidden patterns.",
        price: "₹3,600",
        onlinePrice: "₹3,300 online",
        features: ["Handwriting Analysis", "Signature Analysis", "Personality Deep-Dive", "Detailed Written Report", "Crystal Remedies & Therapy", "Grapho Therapy", "6 Months Follow-Up"],
        featured: false,
    },
];

export const TESTIMONIALS = [
    {
        quote: "A beautiful experience that gave me a completely different perspective on myself. Maitrii ma'am read my handwriting like an open book.",
        name: "Priya S.",
        service: "Handwriting Analysis",
    },
    {
        quote: "The name correction changed things for my business within months. Her insights are uncannily accurate and deeply comforting.",
        name: "Rahul M.",
        service: "Name Correction",
    },
    {
        quote: "I was sceptical about numerology, but the life path reading was so precise it felt personal. Highly recommended for anyone feeling stuck.",
        name: "Sneha K.",
        service: "Numerology Reading",
    },
    {
        quote: "She counselled us through a rough patch using our handwriting compatibility. Grateful for her warmth and wisdom.",
        name: "Amit & Neha",
        service: "Relationship Insights",
    },
    {
        quote: "My son's student analysis helped us understand his learning style completely. A gift for any parent.",
        name: "Deepa R.",
        service: "Child / Student Analysis",
    },
];

export const LIFE_PATH = {
    1: { title: "The Leader", text: "Independent, ambitious and pioneering. You are born to initiate and lead." },
    2: { title: "The Peacemaker", text: "Sensitive, diplomatic and intuitive. Harmony is your superpower." },
    3: { title: "The Creator", text: "Expressive, joyful and artistic. You are here to inspire through words and creativity." },
    4: { title: "The Builder", text: "Grounded, disciplined and dependable. You turn dreams into structures." },
    5: { title: "The Free Spirit", text: "Adventurous, versatile and magnetic. Change is your natural habitat." },
    6: { title: "The Nurturer", text: "Loving, responsible and protective. You heal through care and beauty." },
    7: { title: "The Seeker", text: "Analytical, spiritual and introspective. Truth is your compass." },
    8: { title: "The Powerhouse", text: "Driven, authoritative and abundant. You master the material world." },
    9: { title: "The Humanitarian", text: "Compassionate, wise and generous. You are here to serve the world." },
    11: { title: "The Intuitive", text: "A master number — heightened spiritual insight and inspiration." },
    22: { title: "The Master Builder", text: "A master number — the power to turn grand visions into reality." },
    33: { title: "The Master Teacher", text: "A master number — selfless service, healing and upliftment." },
};

export const computeLifePath = (dob) => {
    const digits = dob.replace(/[^0-9]/g, "").split("").map(Number);
    let sum = digits.reduce((a, b) => a + b, 0);
    while (sum > 9 && ![11, 22, 33].includes(sum)) {
        sum = String(sum).split("").map(Number).reduce((a, b) => a + b, 0);
    }
    return sum;
};
